import type { ReactNode } from "react";

import type { FormFieldConfig } from "@checkout-v2/formFields";

type CheckboxFieldExtraParams = {
  labelHtml?: ReactNode;
};

export type CheckboxFieldConfig<Name extends string = string, Data = object> = FormFieldConfig<
  Name,
  CheckboxFieldExtraParams & Data
>;
